var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._g({staticClass:"btn-edit",attrs:{"href":"javascript:;"},domProps:{"textContent":_vm._s(_vm.label)}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }